import { AxiosPromise } from 'axios';

import { axios } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { serviceLocals } from 'src/locals';
import { queryTypes, serviceIncidentFolderTypes, serviceIncidentTypes } from 'src/types';
import { MapUnit } from 'src/types/unit.type';
import { fileHelper, urlHelper } from '../helpers';

export const lookupIncidentTable = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: serviceIncidentTypes.IncidentLookupDataType): AxiosPromise<serviceIncidentTypes.IncidentTableLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    return axios.get(urlHelper.addQueryParameters({ search: value }, urlsConfig.incident.lookupIncident), {
      blockSpinner,
    });
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.incident.lookupIncident), {
    blockSpinner,
  });
};

export const listAllIncident = (
  options: { blockErrorHandler: boolean },
  id?: string,
): AxiosPromise<serviceIncidentTypes.IncidentAllResultType[]> => {
  const query: { id?: string } = {};

  if (id) {
    query.id = id;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.incident.allIncidentList), {
    blockErrorHandler: true,
  });
};

export const createIncident = (
  form: serviceIncidentTypes.IncidentCreateDataType,
  // formData: FormData,
  options: { blockErrorHandler: boolean },
) => {
  // const trainingData = fileHelper.convertArrayData(form.secondaryTrainingObjective);
  // const entitiesData = fileHelper.convertArrayData(form.relatedAudienceEntities);
  // const procesesData = fileHelper.convertArrayData(form.relatedAudienceProcesses);

  const formData = fileHelper.convertDataURLsToFormData(form.attachments);

  if (form.eventId) {
    formData.append('eventId', form.eventId);
  }

  if (form.incidentFolderNumberId) {
    formData.append('incidentFolderNumberId', form.incidentFolderNumberId);
  }

  if (form.possibleCommandIds.length > 0) {
    formData.append('possibleCommandIds', form.possibleCommandIds.join(','));
  }

  if (form.incidentNumber) {
    formData.append('incidentNumber', form.incidentNumber);
  }

  if (form.incidentName) {
    formData.append('incidentName', form.incidentName);
  }

  if (form.units.length > 0) {
    for (const key in form.units) {
      if (typeof form.units[key] === 'bigint') {
        form.units[key] = form.units[key].toString();
      }
    }

    formData.append('units', form.units.join(','));
  }

  if (form.primaryTrainingObjectiveId) {
    formData.append('primaryTrainingObjectiveId', form.primaryTrainingObjectiveId);
  }

  if (form.secondaryTrainingObjective && form.secondaryTrainingObjective.length > 0) {
    formData.append('secondaryTrainingObjective', form.secondaryTrainingObjective.join(','));
  }

  if (form.startDateTimeGroup) {
    formData.append('startDateTimeGroup', form.startDateTimeGroup.toString());
  }

  if (form.endDateTimeGroup) {
    formData.append('endDateTimeGroup', form.endDateTimeGroup.toString());
  }

  if (form.relatedAudienceEntities.length > 0) {
    formData.append('relatedAudienceEntities', form.relatedAudienceEntities.join(','));
  }

  if (form.relatedAudienceProcesses.length > 0) {
    formData.append('relatedAudienceProcesses', form.relatedAudienceProcesses.join(','));
  }

  if (form.scenarioConditions) {
    formData.append('scenarioConditions', form.scenarioConditions);
  }

  if (form.scenarioConditionStatus) {
    formData.append('scenarioConditionStatus', form.scenarioConditionStatus);
  }

  if (form.milConditions) {
    formData.append('milConditions', form.milConditions);
  }

  if (form.milConditionStatus) {
    formData.append('milConditionStatus', form.milConditionStatus);
  }

  if (form.description) {
    formData.append('description', form.description);
  } else {
    formData.append('description', '');
  }

  // if (form.log) {
  //   formData.append('log', form.log);
  // }

  if (form.comment) {
    formData.append('comment', form.comment);
  } else {
    formData.append('comment', '');
  }

  return axios.post(urlsConfig.incident.createIncident, formData, { headers: serviceLocals.formDataHeader });
};

export const incidentEdit = (
  form: serviceIncidentTypes.IncidentEditDataType,
  // formData: FormData,
): AxiosPromise<serviceIncidentTypes.IncidentEditResultType> => {
  // const trainingData = fileHelper.convertArrayData(form.secondaryTrainingObjective);
  const entitiesData = fileHelper.convertArrayData(form.relatedAudienceEntities);
  const procesesData = fileHelper.convertArrayData(form.relatedAudienceProcesses);
  const formData = fileHelper.convertDataURLsToFormData(form.attachments);

  if (form.id !== undefined) {
    formData.append('id', form.id);
  }

  if (form.deletedAttachments !== undefined) {
    form.deletedAttachments.forEach((eachAttachment: any) => {
      formData.append('deletedAttachments', eachAttachment);
    });
  }

  if (form.possibleCommandIds.length > 0) {
    formData.append('possibleCommandIds', form.possibleCommandIds.join(','));
  }

  if (form.notIncludedActionIds.length > 0) {
    formData.append('notIncludedActionIds', form.notIncludedActionIds.join(','));
  }

  if (form.eventId) {
    formData.append('eventId', form.eventId);
  }

  if (form.incidentFolderNumberId) {
    formData.append('incidentFolderNumberId', form.incidentFolderNumberId);
  }

  if (form.incidentNumber) {
    formData.append('incidentNumber', form.incidentNumber);
  }

  if (form.incidentName) {
    formData.append('incidentName', form.incidentName);
  }
  if (form.units.length > 0) {
    for (const key in form.units) {
      if (typeof form.units[key] === 'bigint') {
        form.units[key] = form.units[key].toString();
      }
    }

    formData.append('units', form.units.join(','));
  }

  if (form.primaryTrainingObjectiveId) {
    formData.append('primaryTrainingObjectiveId', form.primaryTrainingObjectiveId);
  }

  if (form.secondaryTrainingObjective.length > 0) {
    formData.append('secondaryTrainingObjective', form.secondaryTrainingObjective.join(','));
  }

  if (form.startDateTimeGroup) {
    formData.append('startDateTimeGroup', form.startDateTimeGroup.toString());
  }

  if (form.endDateTimeGroup) {
    formData.append('endDateTimeGroup', form.endDateTimeGroup.toString());
  }

  if (form.relatedAudienceEntities.length > 0) {
    formData.append('relatedAudienceEntities', form.relatedAudienceEntities.join(','));
  }

  if (form.relatedAudienceProcesses.length > 0) {
    formData.append('relatedAudienceProcesses', form.relatedAudienceProcesses.join(','));
  }

  if (form.scenarioConditions) {
    formData.append('scenarioConditions', form.scenarioConditions);
  }

  if (form.scenarioConditionStatus) {
    formData.append('scenarioConditionStatus', form.scenarioConditionStatus);
  }

  if (form.milConditions) {
    formData.append('milConditions', form.milConditions);
  }

  if (form.milConditionStatus) {
    formData.append('milConditionStatus', form.milConditionStatus);
  }

  if (form.description) {
    formData.append('description', form.description);
  } else {
    formData.append('description', '');
  }

  // if (form.log) {
  //   formData.append('log', form.log);
  // }

  if (form.comment) {
    formData.append('comment', form.comment);
  } else {
    formData.append('comment', '');
  }

  return axios.patch(urlsConfig.incident.incidentEdit, formData, { blockErrorHandler: true });
};

export const incidentMapPositionEdit = (
  form: serviceIncidentTypes.IncidentMapPositionEditDataType,
): AxiosPromise<serviceIncidentTypes.IncidentEditResultType> => {
  return axios.patch(urlsConfig.incident.incidentMapPositionEdit, form, { blockErrorHandler: true });
};

export const incidentDelete = ({
  id,
}: serviceIncidentTypes.IncidentDeleteDataType): AxiosPromise<serviceIncidentTypes.IncidentDeleteResultType> => {
  return axios.delete(`${urlsConfig.incident.incidentDelete}/${id}`);
};
